import { render, staticRenderFns } from "./FloatSelect.vue?vue&type=template&id=3881bc86"
import script from "./FloatSelect.vue?vue&type=script&lang=js"
export * from "./FloatSelect.vue?vue&type=script&lang=js"
import style0 from "./FloatSelect.vue?vue&type=style&index=0&id=3881bc86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports